'use strict'

module.exports = { version: '9.5.0' }
